import { ScopeType } from '~shared/types';

type ResolveAuthKeyParams = {
  scope: ScopeType;
  lessorAccessToken?: string | null;
  tenantAccessToken?: string | null;
};

export const resolveAuthKey = ({
  scope,
  lessorAccessToken,
  tenantAccessToken,
}: ResolveAuthKeyParams) => {
  const activeScopeToken =
    scope === 'lessor' ? lessorAccessToken : tenantAccessToken;
  const fallbackToken =
    scope === 'lessor' ? tenantAccessToken : lessorAccessToken;

  return activeScopeToken || fallbackToken || null;
};
